"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "limbiate": {
    "f3c2f8f5": [{
      "hkey": "5389c66f",
      "slug": "mombello-villaggio-dei-fiori",
      "name": "Mombello-Villaggio dei Fiori",
      "primary": true,
      "skipSearch": false
    }],
    "mombello": [{
      "hkey": "5389c66f",
      "slug": "mombello-villaggio-dei-fiori",
      "name": "Mombello-Villaggio dei Fiori",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "d56b7dfa": [{
      "hkey": "cd3d4e32",
      "slug": "villaggio-dei-giovi-san-francesco",
      "name": "Villaggio dei Giovi-San Francesco",
      "primary": true,
      "skipSearch": false
    }],
    "villaggio-dei-giovi": [{
      "hkey": "cd3d4e32",
      "slug": "villaggio-dei-giovi-san-francesco",
      "name": "Villaggio dei Giovi-San Francesco",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;